import React, { useEffect } from "react";
import { Grid, Typography } from "@mui/material";
import {
  MAutocomplete,
  MDatePicker,
  ResponsiveFormContainer,
} from "@app/components";
import { useFormContext } from "react-hook-form";
import { useUser } from "@services/servicesGenericsTables";
import { KeysTabsAnalysis } from "@app/types/samples.types";
import useAuth from "@app/context/AuthContext";
import { formatDateOrNow } from "@app/utils/formatDate";

const NotApplicableProcessing = () => {
  const form = useFormContext();
  const { userList } = useUser();
  const { user } = useAuth();

  const showForm = form
    .getValues("analysis_type")
    .some((item) => item.codigo === KeysTabsAnalysis.H3_A);

  useEffect(() => {
    if (!form.getValues("processing_analyst_not_applicable")) {
      form.setValue("processing_analyst_not_applicable", user);
      form.setValue("processing_date_time_not_applicable", formatDateOrNow());
    }
  }, []);

  return (
    <>
      {showForm && (
        <>
          <Grid item xs={12} my={2}>
            <Typography variant="tagText">
              {"Alicuota con muestra sin acidificación"}
            </Typography>
          </Grid>
        </>
      )}
      <ResponsiveFormContainer columns={5} mt={1}>
        <MAutocomplete
          key={JSON.stringify(
            form.getValues("processing_analyst_not_applicable")
          )}
          name="processing_analyst_not_applicable"
          options={userList}
          label="Seleccione un analista"
          getOptionLabel={(option) => option.username || ""}
          validation={{ required: "El analista es requerido" }}
        />
        <MDatePicker
          name="processing_date_time_not_applicable"
          pickerType="datetime"
          label="Fecha y hora Inicio"
          validation={{
            required: "La fecha y hora de inicio es requerida",
          }}
        />
      </ResponsiveFormContainer>
    </>
  );
};

export default NotApplicableProcessing;
